import { render, staticRenderFns } from "./SkeletonText.vue?vue&type=template&id=c4e17bcc&scoped=true"
import script from "./SkeletonText.vue?vue&type=script&lang=js"
export * from "./SkeletonText.vue?vue&type=script&lang=js"
import style0 from "./SkeletonText.vue?vue&type=style&index=0&id=c4e17bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e17bcc",
  null
  
)

export default component.exports